import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import { StatusHeader } from "./components/detail/StatusHeader";
import { ProgressDots } from "./components/detail/ProgressDots";
import { ServiceInfoCard } from "./components/detail/ServiceInfoCard";
import { PunchTimelineSection } from "./components/detail/PunchTimelineSection";
import { FeeDetailBar } from "./components/detail/FeeDetailBar";
import { VoucherServiceSection } from "./components/detail/VoucherServiceSection";
import { DetailBtnGroup } from "./components/detailBtnGroup";
import { getOrderDetail } from "@/api/staff";
import type { StaffOrderDetail } from "@/api/staff";

export default function WorkspaceOrderDetailPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = Number(searchParams.get("id") || 0);

  const [orderDetail, setOrderDetail] = useState<StaffOrderDetail | null>(null);
  const [loading, setLoading] = useState(true);

  const loadDetail = async () => {
    if (!orderId) return;
    setLoading(true);
    try {
      const d = await getOrderDetail(orderId);
      setOrderDetail(d);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  if (loading || !orderDetail) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <i className="ri-loader-4-line text-2xl animate-spin text-gray-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-[calc(env(safe-area-inset-bottom,0px)+96px)] bg-gray-50">
      {/* 渐变头部区域 */}
      <div
        className="relative pb-6 px-5 overflow-hidden"
        style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)", background: "linear-gradient(180deg, #2C2C3A 0%, #3D3A4D 60%, #4A4558 100%)" }}
      >
        <StatusHeader orderInfo={orderDetail} onBack={() => navigate(-1)} />
        <ProgressDots orderInfo={orderDetail} />
      </div>

      {/* 内容区 */}
      <div className="px-4 -mt-2 space-y-3">
        <ServiceInfoCard orderInfo={orderDetail} onCall={() => alert(`联系：${orderDetail.link_phone}`)} />
        <PunchTimelineSection orderInfo={orderDetail} orderId={orderId} onUpdate={loadDetail} />
        <FeeDetailBar orderInfo={orderDetail} />
        <VoucherServiceSection orderInfo={orderDetail} />
      </div>

      {/* 底部操作按钮 - 按原型图布局 */}
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-100 px-4 flex gap-3 z-30" style={{ paddingTop: "8px", paddingBottom: "calc(8px + env(safe-area-inset-bottom, 0px))" }}>
        <button
          onClick={() => alert(`联系客户：${orderDetail.link_phone}`)}
          className="shrink-0 py-2.5 px-6 rounded-full text-sm font-medium active:scale-[0.98]"
          style={{ color: "#00BFA5", background: "#E0F7F4", border: "1px solid #B2DFDB" }}
        >
          联系客户
        </button>
        {(orderDetail.status > 0 && orderDetail.status < 50) && (
          <DetailBtnGroup orderInfo={orderDetail} onUpdate={loadDetail} />
        )}
      </div>

      {/* 紧急联系人悬浮按钮 */}
      <button
        type="button"
        onClick={() => navigate("/workspace/emergency")}
        className="fixed right-4 bottom-24 w-11 h-11 rounded-full shadow-lg flex items-center justify-center active:scale-[0.98] z-40"
        style={{ background: "#FE7A3A" }}
        aria-label="紧急联系人"
      >
        <i className="ri-phone-fill text-white" style={{ fontSize: 18 }} />
      </button>
    </div>
  );
}
